export { default } from './wistia';
export { default as wistiaConfig } from './wistia.config';
